/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamTranscribeJobParams } from './oralExamTranscribeJobParams';

/**
 * Request model for oral exam transcription job
 */
export interface RunOralExamTranscribeJobRequest {
  type: 'oral_exam_transcribe';
  params: OralExamTranscribeJobParams;
  allowOverlappingJobs?: boolean;
}
